import React from "react";
import { useParams, Navigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Box, Typography, Container, useTheme } from "@mui/material";
import SettingsSidebar from "./SettingsSidebar";
import SettingsPlaceholderPanel from "./SettingsPlaceholderPanel";
import ChangePassword from "./ChangePassword";
import TwoFactorAuth from "./TwoFactorAuth";
import { findSettingsItem, getDefaultSettingsPath } from "./settingsConfig";

const Settings = () => {
  const theme = useTheme();
  const { section, item } = useParams();

  const match = section && item ? findSettingsItem(section, item) : null;

  if (!match) {
    return <Navigate to={getDefaultSettingsPath()} replace />;
  }

  return (
    <>
      <Helmet>
        <title>Settings | Vantage Alpha</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: theme.palette.grey[50],
          minHeight: "100vh",
          py: 3,
        }}
      >
        <Container maxWidth="xl">
          <Box sx={{ mb: 3 }}>
            <Typography
              variant="h4"
              sx={{ fontWeight: 600, color: theme.palette.text.primary, mb: 1 }}
            >
              Settings
            </Typography>
            <Typography variant="body1" sx={{ color: theme.palette.text.secondary }}>
              Manage your account preferences and security options
            </Typography>
          </Box>

          <Box sx={{ display: "flex", gap: 3, alignItems: "flex-start" }}>
            <SettingsSidebar activeSection={section} activeItem={item} />
            {match.section.key === "security" && match.item.key === "change-password" ? (
              <ChangePassword />
            ) : match.section.key === "security" && match.item.key === "two-factor" ? (
              <TwoFactorAuth />
            ) : (
              <SettingsPlaceholderPanel
                icon={match.item.icon}
                label={match.item.label}
                description={match.item.description}
              />
            )}
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default Settings;
